export const snakeCaseToSpace = (string: string | undefined): string =>
  `${string}`.split('_').join(' ');
